// @flow

import _ from 'lodash';
import I18n from '../i18n/I18n';

export default class CurrencyUtils {

  static formatPriceWithCurrency(price: number, currencyCode: string = 'EUR'): string {
    return Intl.NumberFormat(
        undefined, // use current locale
        {currency: currencyCode, style: 'currency'}).format(price);
  }



  static formatPrice(price: number): string {
    const priceAsFloat = parseFloat(price);
    return priceAsFloat.toFixed(2);
  }

  static formatMillionPrice(price: number): string {
    const priceAsFloat = parseFloat(price / 1000000);
    return priceAsFloat.toFixed(2);
  }

  static formatMillionPriceWithCurrency(price: number, currencyCode: string = 'EUR'): string {
    const priceAsFloat = parseFloat(price / 1000000);
    return CurrencyUtils.formatPriceWithCurrency(priceAsFloat, currencyCode)
  }

  static formatTax(tax: number): string {
    const taxAsFloat = parseFloat(tax);
    return `${taxAsFloat.toFixed(1)} %`;
  }

  static getCodeNameCorrespondance() {
    return {
      EUR: I18n.getCurrencyName('EUR'),
      USD: I18n.getCurrencyName('USD'),
      GBP: I18n.getCurrencyName('GBP'),
      PLN: I18n.getCurrencyName('PLN'),
      CHF: I18n.getCurrencyName('CHF'),
      NOK: I18n.getCurrencyName('NOK'),
      SEK: I18n.getCurrencyName('SEK'),
      DKK: I18n.getCurrencyName('DKK'),
    };
  }

  static getCodeSymbolCorrespondance() {
    return {
      EUR: '€',
      USD: 'USD',
      GBP: 'GBP',
      PLN: 'PLN',
      CHF: 'CHF',
      NOK: 'NOK',
      SEK: 'SEK',
      DKK: 'DKK',
    };
  }

  static getNameForCode(code: string): string {
    let res = code;
    _.forIn(CurrencyUtils.getCodeNameCorrespondance(), (value, key) => {
      if (code === key) {
        res = value;
        return false; // quit loop
      }
    });

    return res;
  }

  /**
   * Prefer using formatPriceWithCurrency if you have an associated amount.
   * Use this method only if you need the symbol without having associated amount
   */
  static getCurrencySymbol(currencyCode: string = 'EUR'): string {
    let res = currencyCode;
    _.forIn(CurrencyUtils.getCodeSymbolCorrespondance(), (value, key) => {
      if (currencyCode === key) {
        res = value;
        return false; // quit loop
      }
    });

    return res;
  }

  static getNameForSymbol(symbol: string): string {
    let res = symbol;
    _.forIn(CurrencyUtils.getCodeSymbolCorrespondance(), (value, key) => {
      if (value === symbol) {
        res = key;
        return false; // quit loop
      }
    });

    return res;
  }

  /**
   * Return all the currency available on the API.
   */
  static getApiCurrencyOptions() {
    return [
      { value: 'EUR', label: I18n.getCurrencyName('EUR') },
      { value: 'USD', label: I18n.getCurrencyName('USD') },
      { value: 'GBP', label: I18n.getCurrencyName('GBP') },
      { value: 'PLN', label: I18n.getCurrencyName('PLN') },
      { value: 'CHF', label: I18n.getCurrencyName('CHF') },
      { value: 'NOK', label: I18n.getCurrencyName('NOK') },
      { value: 'SEK', label: I18n.getCurrencyName('SEK') },
      { value: 'DKK', label: I18n.getCurrencyName('DKK') }
    ];
  }

}



// WEBPACK FOOTER //
// ./sdk/scripts/utils/CurrencyUtils.js